import { Box } from 'components/Box/Box';
import { Button } from 'components/Button/Button';
import { LegacyTertiaryButton } from 'components/LegacyButton/LegacyTertiaryButton';
import { BodySmall } from 'components/Text/BodySmall';
import { colors } from 'theme/theme';

import { Card } from './Card';
import { Container } from './Container';
import { BigButton } from './JobSelector.styled';

type JobSibling = {
  description: string;
  family: { id: string; name: string };
  id: string;
  level: number;
  name: string;
  subFamily: { id: string };
  synonyms: {
    id: string;
    name: string;
  }[];
};

function getSynyonymId(sibling: JobSibling) {
  const synonym = sibling.synonyms.find((s) => s.name === sibling.name);
  return synonym ? synonym.id : null;
}

type Props = {
  onSelect: (arg0: {
    familyId: string;
    name: string;
    id: string;
    synonymId: string | null;
  }) => void;
  onReset: () => void;
  siblings: JobSibling[];
  setRelatedJobsShowing: (arg0: boolean) => void;
};

export function RelatedJobs({
  setRelatedJobsShowing,
  siblings,
  onSelect,
  onReset,
}: Props) {
  return (
    <Container>
      <Box pt={[12, null, 24]} mx={20}>
        <BodySmall>{getText('Try one of these')}&hellip;</BodySmall>
      </Box>

      {siblings.map((sibling) => (
        <Box
          key={sibling.id}
          pb="15px"
          mt="10px"
          mb="15px"
          borderBottom={`1px solid ${colors.selectionGrey}`}
        >
          <BigButton
            data-qa-id="job-sibling"
            onClick={() => {
              setRelatedJobsShowing(false);
              onSelect({
                name: sibling.name,
                id: sibling.id,
                familyId: sibling.family.id,
                synonymId: getSynyonymId(sibling),
              });
            }}
            key={sibling.id}
          >
            <Card
              content={sibling}
              cta={
                <Button type="button" variant="primary" size="small">
                  {getText('Choose Title')}
                </Button>
              }
            />
          </BigButton>
        </Box>
      ))}
      <Box mt="10px">
        <LegacyTertiaryButton
          onClick={() => {
            onReset();
            setRelatedJobsShowing(false);
          }}
        >
          <BodySmall styleAs="h5">
            {getText('These do not match my job')}
          </BodySmall>
        </LegacyTertiaryButton>
      </Box>
    </Container>
  );
}
